
<div class="status-popover">
    <span [ngbPopover]="value" container="body" popoverClass="CXoneMgtPopover" placement="bottom-left" 
        triggers="manual" [openDelay]="400" #popoverText="ngbPopover" (mouseenter)="showTextPopover(popoverText)"
        (mouseleave)="hideTextPopover(popoverText)"
        [disablePopover]="params.value === null || params.value === ''" 
        [innerHTML]="value | boldText:searchFilter:minSearchLength" class="textContent">
    </span>
    <span id="status-icon" *ngIf="iconDetail?.iconType !== iconType.None" 
        [popover]="popoverTemplate" #popoverIconMsg="bs-popover" 
        (mouseenter)="showPopover(popoverIconMsg)" (mouseleave)="popoverIconMsg.hide()"
        container="body" placement="bottom" containerClass="cxone-status-popover"
        triggers="manual">
        <svg class="icon-16 red-icon-fill" *ngIf="iconDetail?.iconType === iconType.Inactive">
            <use href="../App_Themes/CXone/icons/cxone-status-inactive.svg#cxone-status-inactive"></use>
        </svg>
        <svg class="icon-16 red-icon-fill" *ngIf="iconDetail?.iconType === iconType.Failed">
            <use href="../App_Themes/CXone/icons/cxone-status-failed.svg#cxone-status-failed"></use>
        </svg>
    </span>
</div>

<ng-template #popoverTemplate>
    <div class="popover-wrapper">
        <div class="message">{{iconDetail?.popoverMsg}}</div>
    </div>
</ng-template>
